<!--
 * @Author: scg
 * @Date: 2022-01-08 09:46:44
 * @LastEditTime: 2022-01-08 10:27:05
 * @LastEditors: scg
 * @Description:
-->
<template>
  <view class="account-box">
    <view class="title">{{ $t("lastMap.locations") }}</view>
    <div class="mapbox-maps">
      <div id="map" v-if="showMap"></div>
    </div>
    <!-- <div class="google-map" id="map"></div> -->
    <!-- <image src="../../static/image/mapData.png" style="width: 100%;height: 360rpx;border-radius: 16rpx;" mode=""></image> -->
    <!-- 列表 -->
    <view class="list-box" v-for="(item, index) in dataList" :key="index">
      <view class="round-box"></view>
      <view class="item-test">
        <view class="item-test-top">{{ item.address }}</view>
        <view class="item-test-bottom">{{ item.createtime }}</view>
      </view>
    </view>
    <view style="width: 100%; height: 1px; background-color: #e1e3e6"></view>
    <view class="blue-test" @click="toDetail">{{ $t("lastMap.all") }}</view>
  </view>
</template>

<script>
import { lastgps, getMapKeys } from "@/api/user.js";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
export default {
  data() {
    return {
      dataList: [],
      infowindows: [],
      map: null,
      showMap: false,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
    };
  },
  computed: {},
  mounted() {
    this.init();
  },
  methods: {
    toDetail() {},
    async init() {
      this.showMap = false;
      const { data } = await lastgps({
        equipment_id: localStorage.getItem("systemId"),
      });
      this.dataList = data;
      if (data && data.length > 0) {
        this.lat = Number(data[0].latitude);
        this.lng = Number(data[0].longitude);
      }
      console.log(this.dataList);
      this.initMap();
    },
    async initMap() {
      this.showMap = true;
      const ddd = await getMapKeys();
      let myIcon = L.icon({
        iconUrl: require("./../assets/img/lastMap.png"),
        iconSize: [27, 40],
        iconAnchor: [15, 32],
      });

      this.map = L.map("map", {
        center: [this.lat, this.lng], // 地图中心
        zoom: 15, //缩放比列
        zoomControl: false, //禁用 + - 按钮
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
      });
      // styles/
      let name = L.tileLayer(
        // "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        // "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
        `https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${ddd.data.key}`,
        {
          minZoom: 5,
          maxZoom: 18,
        }
      ).addTo(this.map);

      if (this.dataList.length > 0) {
        var latlngs = this.dataList.map((item) => {
          return [item.latitude, item.longitude];
        });
        if (latlngs.length > 0) {
          let polyline = L.polyline(latlngs, {
            color: "#289329",
          }).addTo(this.map);
          this.map.fitBounds(polyline.getBounds());
        }

        let datas = this.$arrGroup(
          this.dataList,
          (item) => item.latitude && item.longitude
        );
        let popups = this.$initMapPopups(datas);
        function marker(list, map, index = 0) {
          L.marker([list[index].latitude, list[index].longitude], {
            icon: myIcon,
          })
            .addTo(map)
            .on("click", function () {
              if (popups[[list[index].latitude, list[index].longitude]]) {
                map.openPopup(
                  popups[[list[index].latitude, list[index].longitude]]
                );
              }
            });
          if (list.length - 1 > index) {
            marker(list, map, index + 1);
          }
        }
        marker(this.dataList, this.map);
      }
    },
  
  },
};
</script>

<style scoped>
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.css");
.account-box {
  padding: 32rpx 40rpx;
  box-sizing: border-box;
  background-color: #fff;
  margin: 24rpx;
  border-radius: 24rpx;
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
}
.account-box .blue-test {
  font-size: 14px;
  color: #0080ff;
  text-align: center;
  font-weight: 400;
  padding-top: 32rpx;
}

.account-box .title {
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  margin-bottom: 16rpx;
}

.account-box .list-box {
  padding: 20rpx 0;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
}
.account-box .list-box .round-box {
  width: 16rpx;
  height: 16rpx;
  background-color: #0cd4b0;
  border-radius: 50%;
  margin-top: 10rpx;
}
.account-box .list-box .item-test {
  margin-left: 24rpx;
  width: calc(100% - 16rpx - 24rpx);
}
.account-box .list-box .item-test .item-test-bottom {
  font-size: 12px;
  color: #b4b5b8;
  font-weight: 400;
}
.account-box .list-box .item-test .item-test-top {
  font-size: 13px;
  color: #000927;
  font-weight: 400;
}
.google-map {
  width: 100%;
  height: 200px;
}
.mapbox-maps {
  width: 100%;
  height: 200px;
  position: relative;
  #map {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    .mapboxgl-canvas {
      outline: none;
    }
    // 隐藏mapbox商标
    .mapboxgl-ctrl-logo {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lastMap.vue